/**
 * OrderFormActions - Action buttons and validation display component
 */
import React from 'react';
import { OrderSide } from './types';
import { formatCurrency } from '../../utils/formatNumber';

interface OrderFormActionsProps {
  side: OrderSide;
  loading: boolean;
  error: string | null;
  estimatedAmount: number;
  accountCash: number;
  validationError: string | null;
  isOrderValid: boolean;
}

const OrderFormActions: React.FC<OrderFormActionsProps> = ({
  side,
  loading,
  error,
  estimatedAmount,
  accountCash,
  validationError,
  isOrderValid,
}) => {
  return (
    <>
      {/* Estimated Amount */}
      {estimatedAmount > 0 && (
        <div className="estimated-amount">
          <div className="amount-label">예상 주문 금액</div>
          <div className={`amount-value ${validationError ? 'insufficient' : 'sufficient'}`}>
            {formatCurrency(estimatedAmount)}
          </div>
          {side === 'buy' && accountCash > 0 && (
            <div className="amount-info">보유 잔고: {formatCurrency(accountCash)}</div>
          )}
        </div>
      )}

      {/* Validation Error */}
      {validationError && (
        <div className="form-error">{validationError}</div>
      )}

      {/* Submit Error */}
      {error && (
        <div className="form-error">{error}</div>
      )}

      {/* Submit Button */}
      <button
        type="submit"
        className={`submit-btn ${side}`}
        disabled={loading || !isOrderValid}
      >
        {loading ? '주문 중...' : side === 'buy' ? '매수 주문' : '매도 주문'}
      </button>
    </>
  );
};

export default OrderFormActions;
